/**
 * @generated SignedSource<<a4c673d35ae48a847e10411d9894c25f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AppAuthAPIConnectionSectionQuery$variables = {
  appId: string;
};
export type AppAuthAPIConnectionSectionQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly cloudUrls: ReadonlyArray<{
        readonly httpEnabled: boolean;
        readonly url: string;
        readonly wsEnabled: boolean;
      }>;
      readonly viewerCanCreateApiKey: boolean;
      readonly viewerCanDeleteApiKey: boolean;
      readonly viewerCanReadApiKey: boolean;
    } | null;
  };
};
export type AppAuthAPIConnectionSectionQuery = {
  response: AppAuthAPIConnectionSectionQuery$data;
  variables: AppAuthAPIConnectionSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wsEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "httpEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReadApiKey",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanCreateApiKey",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDeleteApiKey",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppAuthAPIConnectionSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppDomainStatus",
                "kind": "LinkedField",
                "name": "cloudUrls",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppAuthAPIConnectionSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppDomainStatus",
                "kind": "LinkedField",
                "name": "cloudUrls",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34bed8938e7d2e6607fcdc5caf60bd76",
    "id": null,
    "metadata": {},
    "name": "AppAuthAPIConnectionSectionQuery",
    "operationKind": "query",
    "text": "query AppAuthAPIConnectionSectionQuery(\n  $appId: ID!\n) {\n  viewer {\n    appById(id: $appId) {\n      cloudUrls {\n        url\n        wsEnabled\n        httpEnabled\n        id\n      }\n      viewerCanReadApiKey\n      viewerCanCreateApiKey\n      viewerCanDeleteApiKey\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f24665f9c6cdbbb689003b1c3df9c90";

export default node;
